module.exports = __webpack_public_path__ + "static/media/pumps.0b9afccd.jpg";